import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ReportDataStreamResp_AllowedConditionCodesMap } from '@/shared/api/protocol-ts/api/core/svc_report_pb';
import { SliceName } from '@/shared/config';

import { AllowedConditionCodesByKey } from '../config';
import { getAllowedConditionCodesKey } from '../lib';

type AllowedToothConditionsState = {
  conditionCodesByKey: AllowedConditionCodesByKey | null;
};

const initialState: AllowedToothConditionsState = {
  conditionCodesByKey: null,
};

const allowedToothConditionsSlice = createSlice({
  name: SliceName.allowedToothConditions,
  initialState,
  reducers: {
    setConditionCodesMap: (
      state,
      action: PayloadAction<ReportDataStreamResp_AllowedConditionCodesMap>,
    ) => {
      state.conditionCodesByKey = Object.fromEntries(
        action.payload.Items.map((item) => [
          getAllowedConditionCodesKey(item.ToothType, item.ToothPosition),
          item.ConditionCodes,
        ]),
      );
    },
    reset: () => initialState,
  },
});

export const { actions } = allowedToothConditionsSlice;

export default allowedToothConditionsSlice.reducer;
